const t = (e) => (e.setHours(0, 0, 0, 0), e);
export {
  t as setDateSince
};
